<template>
    <el-aside width="200px" style="text-align: left;">
        <el-radio-group v-model="isCollapse" style="margin-bottom: 20px;" v-if="displayCollapseBtn">
            <el-radio-button :label="false">展开</el-radio-button>
            <el-radio-button :label="true">收起</el-radio-button>
        </el-radio-group>

        <el-menu default-active="/home/dashboard" active-text-color="#ffffff" class="el-menu-vertical-demo" @open="handleOpen" @close="handleClose" @select="selectMenuItem" :collapse="isCollapse">
            <el-submenu v-for="(item, index) in mapMenuNavs" :key="item.index" :index="item.index">
                <template slot="title">
                    <i :class="item.icon"></i>
                    <span slot="title">{{ item.name }}</span>
                </template>
                <el-menu-item v-for="(key, i) in item.items" :index="key.index" class="child-menu-title"><i :class="key.icon"></i>{{ key.name }}</el-menu-item>
            </el-submenu>
        </el-menu>

    </el-aside>
</template>

<style>
  .el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 200px;
    min-height: 400px;
  }
</style>

<script>
export default {
  name: 'header_nav_menu',
  data() {
    return {
        isCollapse: false,
        displayCollapseBtn: false,
        mapMenuNavs: [
            {
                index: "1",
                id: "a",
                name: "系统管理",
                icon: "el-icon-s-home",
                items: [
                    {
                        index: "/home/dashboard",
                        id: "a1",
                        name: "首页",
                        icon: "el-icon-document",
                    },
                    {
                        index: "/sys/opt_logs",
                        id: "a2",
                        name: "操作日志",
                        icon: "el-icon-document",
                    },
                    {
                        index: "/sys/login_logs",
                        id: "a3",
                        name: "登录日志",
                        icon: "el-icon-document",
                    }
                ]
            },
            {
                index: "2",
                id: "b",
                name: "组织/部门管理",
                icon: "el-icon-folder-opened",
                items: [
                    {
                        index: "/hold/manage",
                        id: "b1",
                        name: "组织/部门",
                        icon: "el-icon-document",
                    },
                    {
                        index: "/staff/manage",
                        id: "b2",
                        name: "账号",
                        icon: "el-icon-document",
                    }
                ]
            },
            {
                index: "3",
                id: "c",
                name: "设备/卡管理",
                icon: "el-icon-user",
                items: [
                    {
                        index: "/device/manage",
                        id: "c1",
                        name: "设备管理",
                        icon: "el-icon-document",
                    },
                    {
                        index: "/patrol/card_manage",
                        id: "c2",
                        name: "巡检点管理",
                        icon: "el-icon-document",
                    }
                ]
            },
            {
                index: "4",
                id: "d",
                name: "巡检记录",
                icon: "el-icon-data-line",
                items: [
                    {
                        index: "/patrol/records",
                        id: "d1",
                        name: "巡检记录",
                        icon: "el-icon-document",
                    },
                    {
                        index: "/patrol/total_by_pointer",
                        id: "d2",
                        name: "巡检统计（按巡检点）",
                        icon: "el-icon-document",
                    },
                    {
                        index: "/patrol/total_by_device",
                        id: "d3",
                        name: "巡检统计（按设备）",
                        icon: "el-icon-document",
                    }
                ]
            },
            {
                index: "5",
                id: "e",
                name: "巡检线路和任务",
                icon: "el-icon-date",
                items: [
                    {
                        index: "/road/manage",
                        id: "e1",
                        name: "巡检线路管理",
                        icon: "el-icon-document",
                    },
                    {
                        index: "/patrol/tasks",
                        id: "e2",
                        name: "巡检任务管理",
                        icon: "el-icon-document",
                    }
                ]
            }
        ]
    }
  },
  methods: {
      handleOpen(key, keyPath) {
        console.log(key, keyPath);
      },
      handleClose(key, keyPath) {
        console.log(key, keyPath);
      },
      selectMenuItem(index, indexPath) {
        //console.log(`index=${index}, indexPath=${indexPath}`);
        this.$router.push(index);

        var obj = {};
        for(var i=0; i<this.mapMenuNavs.length; i++) {
            for(var j=0; j<this.mapMenuNavs[i].items.length; j++) {
                if(this.mapMenuNavs[i].items[j].index === index) {
                    obj = {
                        id: this.mapMenuNavs[i].items[j].id,
                        name: this.mapMenuNavs[i].items[j].name,
                        path: this.mapMenuNavs[i].items[j].index
                    };
                    break;
                }
            }
        }

        this.$emit('eventSelectItemPath', obj);
        
      }
    }
}
</script>